/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  UpdateUserKYCOptions,
  UpdateUserKYCStatus200,
  UpdateUserKYCStatus400,
  UpdateUserKYCStatus401,
  UpdateUserKYCStatus403,
  UpdateUserKYCStatus404,
  UpdateUserKYCStatus500,
} from '../types/UpdateUserKYC'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { updateUserKYC } from '../clients/updateUserKYC'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const updateUserKYCMutationKey = () =>
  [{ url: '/v1/integrators/user/:user_id/kyc' }] as const

export function updateUserKYCMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = updateUserKYCMutationKey()
  return mutationOptions<
    UpdateUserKYCStatus200,
    ResponseErrorConfig<
      | UpdateUserKYCStatus400
      | UpdateUserKYCStatus401
      | UpdateUserKYCStatus403
      | UpdateUserKYCStatus404
      | UpdateUserKYCStatus500
    >,
    UpdateUserKYCOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ path, body }) => {
      return updateUserKYC({ ...config, path, body, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @summary Set or clear a user's KYC completion timestamp
 * {@link /v1/integrators/user/:user_id/kyc}
 */
export function useUpdateUserKYC<TContext>(
  options: {
    mutation?: UseMutationOptions<
      UpdateUserKYCStatus200,
      ResponseErrorConfig<
        | UpdateUserKYCStatus400
        | UpdateUserKYCStatus401
        | UpdateUserKYCStatus403
        | UpdateUserKYCStatus404
        | UpdateUserKYCStatus500
      >,
      UpdateUserKYCOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? updateUserKYCMutationKey()

  const baseOptions = updateUserKYCMutationOptions(config) as UseMutationOptions<
    UpdateUserKYCStatus200,
    ResponseErrorConfig<
      | UpdateUserKYCStatus400
      | UpdateUserKYCStatus401
      | UpdateUserKYCStatus403
      | UpdateUserKYCStatus404
      | UpdateUserKYCStatus500
    >,
    UpdateUserKYCOptions,
    TContext
  >

  return useMutation<
    UpdateUserKYCStatus200,
    ResponseErrorConfig<
      | UpdateUserKYCStatus400
      | UpdateUserKYCStatus401
      | UpdateUserKYCStatus403
      | UpdateUserKYCStatus404
      | UpdateUserKYCStatus500
    >,
    UpdateUserKYCOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    UpdateUserKYCStatus200,
    ResponseErrorConfig<
      | UpdateUserKYCStatus400
      | UpdateUserKYCStatus401
      | UpdateUserKYCStatus403
      | UpdateUserKYCStatus404
      | UpdateUserKYCStatus500
    >,
    UpdateUserKYCOptions,
    TContext
  >
}
